import { useTranslation } from 'react-i18next'

import type { StatusConfig } from '../../components/StatusBadge'

export type CancellationStatus = 'REQUESTED' | 'APPROVED' | 'COMPLETED' | 'REJECTED'

export const CANCELLATION_STATUSES: CancellationStatus[] = [
  'REQUESTED',
  'APPROVED',
  'COMPLETED',
  'REJECTED',
]

const CANCELLATION_STATUS_SET: ReadonlySet<string> = new Set(CANCELLATION_STATUSES)

export function isCancellationStatus(value: string): value is CancellationStatus {
  return CANCELLATION_STATUS_SET.has(value)
}

export type CancellationStatusConfig = Record<CancellationStatus, StatusConfig>

export function useCancellationStatusConfig(): CancellationStatusConfig {
  const { t } = useTranslation()

  return {
    REQUESTED: { color: 'orange', label: t('common.status.cancellationPending') },
    APPROVED: { color: 'green', label: t('common.status.cancellationApproved') },
    COMPLETED: { color: 'blue', label: t('common.status.cancellationCompleted') },
    REJECTED: { color: 'red', label: t('common.status.cancellationRejected') },
  }
}
